import React, { createContext, useEffect, useRef, useState } from 'react';
import MD5 from 'md5';
import PropTypes from 'prop-types';
import BrowserFingerPrint from 'containers/Player/utils/BrowserFingerprint';
import { useSelector } from 'react-redux';
import { ANONYMOUS_USER } from 'constants.js';
import useTracking from '../hooks/useTracking';
import { browserHistory } from 'react-router';
const PlayerContext = createContext(null);

const PlayerProvider = ({ children }) => {
  const [isShowContinuePlayingOpen, setIsShowContinuePlayingOpen] = useState(
    false,
  );
  const [episodeCounter, setEpisodeCounter] = useState(0);
  const seriesTimePlaying = useRef(0);
  const liveTimePlaying = useRef(0);
  const interactionCounter = useRef(0);

  const [interactionWithEpisodes, setInteractionWithEpisodes] = useState({});
  const [hasFetchedEpgs, setHasFetchedEpgs] = useState(false);
  const [showControlSeek, setShowControlSeek] = useState(false);

  const shakaPlayerRef = useRef(null);
  const videoTagRef = useRef(null);
  const vodVideoTagRef = useRef(null);
  const vodShakaPlayerRef = useRef(null);
  const liveVideoTagRef = useRef(null);
  const liveShakaPlayerRef = useRef(null);
  const user = useSelector(store => store.user);
  const deviceIdRef = useRef();;

  useEffect(
    () => {
      if (user.user_id || user?.userType === ANONYMOUS_USER)
        deviceIdRef.current = MD5(
          new BrowserFingerPrint().fingerprint() + user.user_id,
        );
    },
    [user],
  );
  const groupId = browserHistory
    ?.getCurrentLocation()
    ?.pathname?.split('/')?.[3];

  const tracking = useTracking(
    videoTagRef.current,
    deviceIdRef.current,
    groupId,
  );

  return (
    <PlayerContext.Provider
      value={{
        tracking,
        shakaPlayerRef,
        videoTagRef,
        deviceIdRef,
        isShowContinuePlayingOpen,
        setIsShowContinuePlayingOpen,
        episodeCounter,
        setEpisodeCounter,
        interactionCounter,
        interactionWithEpisodes,
        setInteractionWithEpisodes,
        seriesTimePlaying,
        liveTimePlaying,
        vodShakaPlayerRef,
        vodVideoTagRef,
        liveShakaPlayerRef,
        liveVideoTagRef,
        hasFetchedEpgs,
        setHasFetchedEpgs,
        showControlSeek,
        setShowControlSeek,
      }}
    >
      {children}
    </PlayerContext.Provider>
  );
};

PlayerProvider.propTypes = {
  children: PropTypes.node,
};

export { PlayerProvider, PlayerContext };
